import  { handleResponse } from '../utils';
import { API_BASE } from '../config/constants';
import apiCall from './apiCall';

const getAllProducer = async (search) => {
    if(search){
        let url = new URL(`${API_BASE}/producer/getallproducer`);
        const params = { search: search };
        url.search = new URLSearchParams(params);
        
        const requestOptions = {
            method: "GET",
            headers: { 'Content-Type': 'application/json' },
        };

        const response = await fetch(url, requestOptions);
        const producers = await handleResponse(response);
        return producers;
    }
    
}

const getProducersByFilter = async (filter) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS'
        },
        body: JSON.stringify(filter)
    };

    const response = fetch(`${API_BASE}/producer/getproducer`, requestOptions);
    return await handleResponse(response);    
}

const getTotalProducer = async (search) => {
        let url = new URL(`${API_BASE}/producer/gettotalproducer`);
        
        const requestOptions = {
            method: "GET",
            headers: { 'Content-Type': 'application/json' },
        };

        const response = await fetch(url, requestOptions);
        const total_producers = await handleResponse(response);
        return total_producers;
}

const registerProducer = async (formData) => {
    try{
        const producer = await apiCall.post(`${API_BASE}/producer/register`, formData);
        return producer.data;
    }catch(err){
        const error = (err.response.data && err.response.data.message) || "No";
        throw new Error(error);
    }
}

const getProducerTotalCount = async (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS'
        },
        body: JSON.stringify(data)
    };

    const response = fetch(`${API_BASE}/producer/getproducertotalcount`, requestOptions);
    return await handleResponse(response);
}

const removeProducer = async (id) => {
    let url = new URL(`${API_BASE}/producer/${id}`);
    
    const requestOptions = {
        method: "DELETE",
        headers: { 'Content-Type': 'application/json' },
    };

    const response = await fetch(url, requestOptions);
    const removeProducer = await handleResponse(response);
    return removeProducer;
}

const modifyProducer = async (id, formData) => {
    try{
        const modify_producer = await apiCall.put(`${API_BASE}/producer/${id}`, formData);
        return modify_producer.data;
    }catch(err){
        const error = (err.response.data && err.response.data.message) || "Failed Modify Producer";
        throw new Error(error);
    }
}

const downloadProducerImage = async () => {
    let url = new URL(`${API_BASE}/producer/downloadimage`);
    
    const requestOptions = {
        method: "GET",
        headers: { 'Content-Type': 'application/json' },
    };

    const response = await fetch(url, requestOptions);
    const downloadImage = await handleResponse(response);
    return downloadImage;
}

export const producerService = {
    getAllProducer,
    registerProducer,
    getTotalProducer,
    getProducersByFilter,
    getProducerTotalCount,
    removeProducer,
    modifyProducer,
    downloadProducerImage
}